import { Injectable } from '@angular/core';
import { GatewayAPIService } from '../../core/gateway-api.service';
import { MerchantStatement } from './merchantStatement';

@Injectable({
  providedIn: 'root',
})
export class StatementService {
  options = { authenticate: true, setRoot: true, returnAsUrl: false };

  constructor(private api: GatewayAPIService) {}

  checkForNewStatements(mid: string): Promise<number> {
    let data = {
      mid: mid,
    };

    return this.api
      .apiCallSane(
        '/merchant/statements/check',
        'POST',
        this.api.getDefaultHeaders(),
        null,
        data,
        this.options,
      )
      .then((response) => {
        return response.totalNew;
      });
  }

  getMerchantStatements(mid: string): Promise<MerchantStatement[]> {
    let data = {
      mid: mid,
    };

    return this.api.apiCallSane(
      '/merchant/statements',
      'GET',
      this.api.getDefaultHeaders(),
      data,
      null,
      this.options,
    );
  }

  getMerchantStatement(
    mid: string,
    statementHash: string,
    merchantId: string,
    download: boolean,
  ): Promise<any> {
    let data = {
      mid: mid,
      hash: statementHash,
      merchantId: merchantId,
      download: download,
    };

    if (!download) {
      //this.options.returnAsUrl = true;
    }

    return this.api.apiCallSane(
      '/merchant/statement',
      'GET',
      this.api.getPDFHeaders(),
      data,
      null,
      this.options,
    );
  }

  getRecentStatements(userId: string): Promise<MerchantStatement[]> {
    let data = {
      userId: userId,
    };

    return this.api.apiCallSane(
      '/statements/recent',
      'GET',
      this.api.getDefaultHeaders(),
      data,
      null,
      this.options,
    );
  }
}
